import React from 'react';
import '../template-file-css/document-file-template.css';


export const RHCA_OrderForServices = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RHCA_OrderForServices' className='file-pdf-document'>
            <div className='file-template'>


                <h3>CORE Services</h3>

                <table>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Diagnostic code:</span> </td>
                        <td className='w-450'> <span className='eleHeader'>Description:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtDiagnosticCode_1' name='txtDiagnosticCode_1' className='add-only' /> </td>
                        <td className='w-450'> <input type='text'    id='txtDescription_1'    name='txtDescription_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtDiagnosticCode_2' name='txtDiagnosticCode_2' className='add-only' /> </td>
                        <td className='w-450'> <input type='text'    id='txtDescription_2'    name='txtDescription_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtDiagnosticCode_3' name='txtDiagnosticCode_3' className='add-only' /> </td>
                        <td className='w-450'> <input type='text'    id='txtDescription_3'    name='txtDescription_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtDiagnosticCode_4' name='txtDiagnosticCode_4' className='add-only' /> </td>
                        <td className='w-450'> <input type='text'    id='txtDescription_4'    name='txtDescription_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtDiagnosticCode_5' name='txtDiagnosticCode_5' className='add-only' /> </td>
                        <td className='w-450'> <input type='text'    id='txtDescription_5'    name='txtDescription_5' className='add-only' /> </td>
                    </tr>
                </table>



                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader w-750;">C&A Service Name</span></td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbBehav" name="cbBehav" className="add-only" value="cbBehav" />
                            Behavioral Health Assessment
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbServicePlan" name="cbServicePlan" className="add-only" value="cbServicePlan" />
                            Service Plan Development
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbDiagnosticAss" name="cbDiagnosticAss" className="add-only" value="cbDiagnosticAss" />
                            Diagnostic Assessment
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbNurAss" name="cbNurAss" className="add-only" value="cbNurAss" />
                            Nursing Assessment & Health Services
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbPsyco" name="cbPsyco" className="add-only" value="cbPsyco" />
                            Psychological Testing
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbCommunitySupport" name="cbCommunitySupport" className="add-only" value="cbCommunitySupport" />
                            Psychiatric Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbPsychTreat" name="cbPsychTreat" className="add-only" value="cbPsychTreat" />
                            Individual Counseling
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbIndividualCounseling" name="cbIndividualCounseling" className="add-only" value="cbIndividualCounseling" />
                            Crisis Intervention
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbFamilyTraing" name="cbFamilyTraing" className="add-only" value="cbFamilyTraing" />
                            Community Support
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbFamilyCounseling" name="cbFamilyCounseling" className="add-only" value="cbFamilyCounseling" />
                            Medication Management
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbGrpSerTrain" name="cbGrpSerTrain" className="add-only" value="cbGrpSerTrain" />
                            Psychosocial Rehabilitation Individual
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="Checkbox2" name="Checkbox2" className="add-only" value="Checkbox2" />
                            Case Management
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbCrisisInt" name="cbCrisisInt" className="add-only" value="cbCrisisInt" />
                            Addictive Disease Support Services
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbComTrans" name="cbComTrans" className="add-only" value="cbComTrans" />
                            Peer Specialist Support Individual
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbedMgmt" name="cbedMgmt" className="add-only" value="cbedMgmt" />
                            Family Outpatient Services
                        </td>
                        <td className="w-375"   >
                            <input type="checkbox" id="cbedIntensive" name="cbedIntensive" className="add-only" value="cbedIntensive" />
                            Group Outpatient Services
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375"   >
                            <input type="checkbox" id="cbedIntervention" name="cbedIntervention" className="add-only" value="cbedIntervention" />
                            Intensive Family Intervention
                        </td>
                        <td className="w-375"   >
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h5>The above services have been ordered and diagnosis verified by:<br />
                    (Must be signed by Psychologist or Physician or An attached Signed/ Dated Psychological)
                </h5>
                <table>
                    <tr>
                        <td className="w-500 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-500 small"> Signature</td>
                        <td className="w-250 small"> Date</td>
                    </tr>
                    <tr>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-250 small"> Print Name</td>
                        <td className="w-250 small"> Credentials</td>
                        <td className="w-250 small"> License Number</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" id="cbVerbalConsent" name="cbVerbalConsent" className="add-only" value="Yes" /> Verbal consent from Dr. &nbsp;
                    <input type="text" id="txtVerbalConsentDr" name="txtVerbalConsentDr" className="add-only custom-add-only w-250" />
                    (# <input type="text" id="txtVerbalConsentNum" name="txtVerbalConsentNum" className="add-only custom-add-only w-250" />)
                </p>
                <p className='w-750'>
                    <span className="eleHeader w-750;">Date:</span>
                    <input type="date" name="txtSignDate" id="txtSignDate" className="add-only" />

                </p>



            </div>
        </form>

    )
}











